import { collection, getDocs, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase/config.js";

export async function getAllMovements() {
    try {
        const querySnapshot = await getDocs(collection(db, "movements"));
        const allMovements = [];
        querySnapshot.forEach((doc) => {
            allMovements.push({ id: doc.id, ...doc.data() });
        });
        return { success: true, movements: allMovements };
    } catch (error) {
        console.error('Error getting movements:', error);
        return { success: false, error: error.message };
    }
}

export async function getMovementsCount() {
    try {
        const coll = collection(db, "movements");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count;
        return { success: true, count };
    } catch (error) {
        console.error('Error getting movements count:', error);
        return { success: false, error: error.message };
    }
}
